/**
 * Extraction Utilities — Re-exported from @lokascript/framework
 *
 * Pure functions for extracting CSS selectors, string literals, URLs, and numbers
 * from input strings. These are language-independent and used by all tokenizers.
 */

export {
  extractCssSelector,
  isPossessiveMarker,
  extractStringLiteral,
  isUrlStart,
  extractUrl,
  extractNumber,
} from '@lokascript/framework';
